module.exports = __webpack_public_path__ + "media/images/flags/mh-c0b2e372c1a8cb36930ed13adc05d0a8.svg";